<template>
  <AddToBag />
  <DataCollection v-if="showDataCollection" />
  <CookieMessage v-if="!isPlaywright" />
</template>

<script>
import AddToBag from "@/components/add-to-bag/AddToBag.vue";
import DataCollection from "@/components/DataCollection.vue";
import CookieMessage from "@/components/CookieMessage.vue";
import { getParams } from "@/helpers/url.js";

export default {
  name: "GlobalComponent",
  components: {
    AddToBag,
    DataCollection,
    CookieMessage,
  },
  inject: ["isPlaywright"],

  computed: {
    isUtmSource() {
      const params = getParams();
      const utmSource = params.utm_source;
      if (utmSource === "Klaviyo") {
        return true;
      }
      return false;
    },
    showDataCollection() {
      if (this.isPlaywright) {
        return false;
      }
      if (this.isUtmSource) {
        return false;
      }
      if (window.location.pathname === "/pages/flash-sale-signup") {
        return false;
      }
      return true;
    },
  },
};
</script>
